import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';

import { RoutingService } from '@shared/services/routing.service';

import { AppState } from '../app.state';
import { filter, map } from 'rxjs/operators';

export const onboardingGuard: CanMatchFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(AppState.onboardingCompleted)
              .pipe(
                  filter((completed) => completed !== null),
                  map((completed) => {
                    if (completed) {
                      return router.createUrlTree([RoutingService.LOGIN]);
                    }
                    return true;
                  }),
              );
};
